const stripWrappingQuotes = (value: string) => value.replace(/^"|"$/g, '');

export const getEnvVar = (key: string, fallback = ''): string => {
    const value = process.env[key];

    if (value === undefined || value === null) {
        return fallback;
    }

    return typeof value === 'string' ? stripWrappingQuotes(value) : value;
};

export const API_BASE_URL = getEnvVar('API_BASE_URL');
export const SOCKET_URL = getEnvVar('SOCKET_URL');
export const ACCESS_CODE_REQUIRED = getEnvVar('ACCESS_CODE_REQUIRED', 'false');

